export default function(fields) {
  return {
    isAddedByUser: fields.isAddedByUser,
    isCompleted: fields.isCompleted,
    date: fields.date,
    id: fields.id,
    helpers: undefined
  }
}
